import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../lib/axios";
import { API_PORTAL_URL } from "../../../lib/config";
import { ErrorToast } from "../../../components/common/Toast";

export const getAllActiveProperties = createAsyncThunk(
  "Property/FindAllActiveProperty",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Property/FindAllActiveProperty`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Properties:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPropertyByURL = createAsyncThunk(
  "Website/PropertyDetailsByURL",
  async (PropertyURL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Website/PropertyDetailsByURL`,
        { PropertyURL },
      );
      return response.data?.Data as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Property Details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllPropertiesWithGalleryAndFAQ = createAsyncThunk(
  "Property/PropertyListWithGallery",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Property/PropertyListWithGallery`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Properties:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// ─── SERVER (native fetch — call ONLY from Server Components / page.tsx) ────

export async function fetchAllPropertiesWithGalleryAndFAQ() {
  try {
    const res = await fetch(
      `${API_PORTAL_URL}/Property/PropertyListWithGallery`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        next: { revalidate: 1 },
      },
    );
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}
